import { graphql } from "../generated/gql";

export const UserLicensesQuery = graphql(
  `
    query UserLicenses($userId: String!) {
      userLicenses(userId: $userId) {
        licenses {
          active
          name
        }
      }
    }
  `
);
